import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SubSpecialitiesInfo from "../../data/SubSpecialitiesInfo";
import { useParams } from "react-router-dom";

const ModalitiesSection = () => {
  const { slug } = useParams();
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [slidesToShow, setSlidesToShow] = useState(3);

  useEffect(() => {
    const updateSlidesToShow = () => {
      if (window.innerWidth <= 640) {
        setSlidesToShow(1);
      } else if (window.innerWidth <= 920) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };

    updateSlidesToShow();
    window.addEventListener("resize", updateSlidesToShow);
    return () => window.removeEventListener("resize", updateSlidesToShow);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow,
    responsive: [
      {
        breakpoint: 920,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const service = SubSpecialitiesInfo.find((s) => s.slug === slug);
  const modalities = service?.modalities?.list || [];
  const description = service?.modalities?.description || "";

  if (modalities.length === 0) return null;

  return (
    <section className="py-32 font-robout">
      <div className="">
        <h2 className="font-robout capitalize text-[#d78558] font-black md:leading-[5rem] text-3xl md:text-[4.8rem] text-center pb-14 max-w-[80%] mx-auto" data-aos="fade-up" data-aos-delay="300">
          Clarity That Builds Confidence
        </h2>

        {/* Main description text */}
        {description && (
          <p className="text-center text-3xl text-white max-w-3xl mx-auto pb-12" data-aos="fade-up" data-aos-delay="300">
            {description}
          </p>
        )}

        <div className="w-full sm:max-w-[80%] mx-auto px-2 mt-16">
          <Slider {...settings}>
            {modalities.map((modality, idx) => (
              <div key={idx} className="relative px-6" style={{ minHeight: 600 }}>
                <div
                  onMouseEnter={() => setExpandedIndex(idx)}
                  onMouseLeave={() => setExpandedIndex(null)}
                  className="relative transition-all duration-300 ease-in-out shadow-xl cursor-pointer overflow-hidden rounded-xl text-white mb-10"
                  style={{
                    height: expandedIndex === idx ? 550 : 500,
                    backgroundImage: `url(${modality.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div
                    className="absolute bottom-0 left-0 w-full transition-all duration-300 ease-in-out p-4 bg-gradient-to-t from-black/100 to-transparent"
                    style={{
                      height: expandedIndex === idx ? "40%" : "80px",
                    }}
                  >
                    <h3 className="text-xl font-semibold ">{modality.name}</h3>
                    <p
                      className={`text-[17px] mt-1 transition-opacity duration-300 ${
                        expandedIndex === idx ? "opacity-100" : "opacity-0"
                      }`}
                    >
                      {modality.uses.join(", ")}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default ModalitiesSection;
